import HighlightStat from "../../molecules/HighlightStat/HighlightStat";
import "./VigilanceSection.css";
 
const VigilanceSection = () => (
  <section className="dark" id="vigilance">
    <div className="wrap">
      <div className="split">
        <div className="vigilance-text">
          <span className="eyebrow">Jusqu'à 36 heures d'anticipation</span>
          <h2 className="vigilance-h2">
            Une vision de risque en continu{" "}
            <span className="vigilance-h2-accent">pour mieux prévenir plutôt que réagir</span>
          </h2>
          <p className="vigilance-body">
            Plutôt qu’une mise à jour quotidienne, ensemblepourlaforêt.fr propose une prédiction heure par heure du niveau de risque de départ de feu, avec un horizon d'anticipation de 36 heures.
          </p>
          <p className="vigilance-body">
            Cette continuité change la nature même de la prévention : au lieu d'une photographie figée du risque, chacun dispose d'une trajectoire vivante, qui intègre l'évolution horaire des conditions favorables à d’éventuels départs de feu.
          </p>
          <div className="vigilance-stats">
            <HighlightStat target={36} suffix=" h" label="Horizon d'anticipation" />
            <HighlightStat target={12} suffix=" h" label="Fréquence de mise à jour Complète" />
          </div>
        </div>
        <img
          className="section-illustration"
          src="/images/vigilance-illustration1.png"
          alt="Vigilance continue avec mise à jour toutes les 60 minutes"
        />
      </div>
    </div>
  </section>
);
 
export default VigilanceSection;